import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project-imports
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'types/auth';
import { URLS } from 'common/constants';

// ==============================|| AUTH GUARD ||============================== //

export default function AuthGuard({ children }: GuardProps) {
  const { isLoggedIn, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {

      if (!location.pathname.startsWith(URLS.settings)) {
        let progress = 0;
        try {
          const auth = JSON.parse(window.localStorage.getItem('auth') || '');
          progress = auth.session.settings.info.progress;

          if (progress == 1) {

            navigate(URLS.profileSettings, {
              state: {
                from: location.pathname
              },
              replace: true
            });

          }
        } catch (error) {}

      }
      
    } else {
      navigate(URLS.login, {
        state: {
          from: location.pathname
        },
        replace: true
      });
    }
  }, [isLoggedIn, navigate, location]);

  return children;
}
